import { lazy } from 'react';

const Edit = lazy(() => import('./edit'));
const Create = lazy(() => import('./create'));

export { Edit, Create };
